








import Vue from "vue";
import IconButton from "./IconButton.vue"

export default Vue.extend({
  name: "ToolButton",
  components: {
    IconButton
  },
  data: () => ({
    icon: 'mdi-undo'
  }),
});
